var map = {
	"./ABBank.png": 26667,
	"./ACB.png": 67720,
	"./Agribank.png": 20837,
	"./BIDV.png": 54185,
	"./BVBank.png": 69014,
	"./Bacabank.png": 92753,
	"./HDBank.png": 26422,
	"./MBbank.png": 22455,
	"./NamAbank.png": 55843,
	"./Sacombank.png": 83099,
	"./SeAbank.png": 63481,
	"./TPBank.png": 34742,
	"./Techcombank.png": 10195,
	"./VIB.png": 14461,
	"./VPBank.png": 13692,
	"./verified-label.png": 70365,
	"Common/Components/AppFooter/Assets/Icons/Vn/ABBank.png": 26667,
	"Common/Components/AppFooter/Assets/Icons/Vn/ACB.png": 67720,
	"Common/Components/AppFooter/Assets/Icons/Vn/Agribank.png": 20837,
	"Common/Components/AppFooter/Assets/Icons/Vn/BIDV.png": 54185,
	"Common/Components/AppFooter/Assets/Icons/Vn/BVBank.png": 69014,
	"Common/Components/AppFooter/Assets/Icons/Vn/Bacabank.png": 92753,
	"Common/Components/AppFooter/Assets/Icons/Vn/HDBank.png": 26422,
	"Common/Components/AppFooter/Assets/Icons/Vn/MBbank.png": 22455,
	"Common/Components/AppFooter/Assets/Icons/Vn/NamAbank.png": 55843,
	"Common/Components/AppFooter/Assets/Icons/Vn/Sacombank.png": 83099,
	"Common/Components/AppFooter/Assets/Icons/Vn/SeAbank.png": 63481,
	"Common/Components/AppFooter/Assets/Icons/Vn/TPBank.png": 34742,
	"Common/Components/AppFooter/Assets/Icons/Vn/Techcombank.png": 10195,
	"Common/Components/AppFooter/Assets/Icons/Vn/VIB.png": 14461,
	"Common/Components/AppFooter/Assets/Icons/Vn/VPBank.png": 13692,
	"Common/Components/AppFooter/Assets/Icons/Vn/verified-label.png": 70365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8482;